var map = {
	"./assets/1.svg": 13,
	"./assets/10.svg": 14,
	"./assets/2.svg": 15,
	"./assets/3.svg": 16,
	"./assets/4.svg": 17,
	"./assets/5.svg": 18,
	"./assets/5things-logo-white.svg": 19,
	"./assets/6.svg": 20,
	"./assets/7.svg": 21,
	"./assets/8.svg": 22,
	"./assets/9.svg": 23,
	"./assets/CHECK-thick-teal.svg": 24,
	"./assets/CHECK-thick-white.svg": 25,
	"./assets/X-thick-white.svg": 26,
	"./assets/cnn-core-logo.svg": 27,
	"./assets/cnn-logo-badge.svg": 28,
	"./assets/cnn-politics-logo.svg": 29,
	"./assets/facebook.svg": 30,
	"./assets/instagram.svg": 31,
	"./assets/twitter.svg": 32
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42;


//////////////////
// WEBPACK FOOTER
// ./src/media ^\.\/.*\.*
// module id = 42
// module chunks = 0